export const referral = {
  referralMessage: "加入 AYG，享受独家优惠！使用我的推荐链接注册 ",
  referralMessageSlots: "在这里注册并获得10次免费老虎机旋转！",
  referralMessageSports: "创建您的账户并获得独家体育投注奖金！",
  referralMessageBingo: "创建您的账户并获得免费宾果卡！",
  referralMessageCasino: "创建您的账户并获得真人娱乐场免费筹码！",
  selectMessageType: "选择消息类型",
  messageTypeGeneral: "一般",
  messageTypeSlots: "老虎机",
  messageTypeSports: "体育",
  messageTypeBingo: "宾果",
  messageTypeCasino: "娱乐场",
  messagePreview: "消息预览",
  copy: "复制",
  share: "分享",
  scanQR: "扫描二维码",
  scanQRText: "扫描此二维码推荐朋友",
  copyQR: "复制二维码",
  downloadQR: "下载二维码",
  shareQR: "分享二维码",
  qrCopied: "二维码已复制到剪贴板！",
  qrCopyFailed: "复制二维码失败。请尝试下载。",
  recentReferrals: "最近推荐",
  referralProgram: "推荐计划",
  youReferralStatus: "您的推荐状态",
  sharedYourLink: "您可以通过复制并发送或在社交媒体上分享您的推荐链接",
  referralEarnings: "推荐收益",
  referralSummary: "推荐摘要",
  yourReferrals: "您的推荐",
  yourReferralsEarned: "您的推荐收益",
  yourReferralsPendingEarned: "您的待定推荐收益",
  joinedDate: "加入日期",
  date: "日期",
  depositDate: "存款日期",
  status: "状态",
  reward: "奖励",
  active: "活跃",
  inactive: "不活跃",
  noReferralsFound: "未找到最近的推荐。",
  totalReferrals: "推荐总数",
  activeReferrals: "活跃推荐",
  hasDeposited: "已存款",
  yes: "是",
  no: "否",
  pending: "待定",
  paid: "已支付",
  recentEarnings: "最近收益",
  noCommissionsYet: "暂无佣金",
  commission: "佣金",
  totalCommission: "总佣金",
  forgotReferralCode: "忘记在您的个人资料中添加推荐代码？",
  clickHere: "点击这里",
  referralCodePlaceholder: "输入您的推荐代码",
  send: "发送",
  sending: "发送中...",
  referralCodeAppliedSuccess: "推荐代码应用成功！",
  invalidOrInactiveReferralCode: "推荐代码无效或不活跃",
};
